import {priority} from '@priority-software/priority-proto-api/lib';
import {PriorityIcon} from '@priority-software/priority-style-react';
import {Operator} from '@priority-software/priority-utils/lib/operators';
import {texts} from '../../../constants/TextConst';
import {ColumnType} from './column';

export const ApiOperatorMapping = {
    [Operator.Contains]: priority.netitems.shared.ComparisonOperator.Eq,
    [Operator.StartsWith]: priority.netitems.shared.ComparisonOperator.Eq,
    [Operator.EndsWith]: priority.netitems.shared.ComparisonOperator.Eq,
    [Operator.Equals]: priority.netitems.shared.ComparisonOperator.Eq,
    [Operator.NotEquals]: priority.netitems.shared.ComparisonOperator.Ne,
    [Operator.Less]: priority.netitems.shared.ComparisonOperator.Lt,
    [Operator.LessOrEqual]: priority.netitems.shared.ComparisonOperator.Le,
    [Operator.Before]: priority.netitems.shared.ComparisonOperator.Le,
    [Operator.Greater]: priority.netitems.shared.ComparisonOperator.Gt,
    [Operator.GreaterOrEqual]: priority.netitems.shared.ComparisonOperator.Ge,
    [Operator.Later]: priority.netitems.shared.ComparisonOperator.Ge,
    [Operator.Between]: priority.netitems.shared.ComparisonOperator.Between,
    [Operator.Empty]: priority.netitems.shared.ComparisonOperator.IsNull,
    [Operator.NotEmpty]: priority.netitems.shared.ComparisonOperator.IsNotNull
};

export const TextApiOperatorMapping = {
    [Operator.Contains]: priority.netitems.shared.ComparisonOperator.Eq,
    [Operator.StartsWith]: priority.netitems.shared.ComparisonOperator.Eq,
    [Operator.EndsWith]: priority.netitems.shared.ComparisonOperator.Eq,
    [Operator.Equals]: priority.netitems.shared.ComparisonOperator.Eq,
    [Operator.NotEquals]: priority.netitems.shared.ComparisonOperator.Ne,
    [Operator.Empty]: priority.netitems.shared.ComparisonOperator.IsNull,
    [Operator.NotEmpty]: priority.netitems.shared.ComparisonOperator.IsNotNull
};
export const RangeApiOperatorMapping = {
    [priority.netitems.shared.ComparisonOperator.Eq]: Operator.Equals,
    [priority.netitems.shared.ComparisonOperator.Ne]: Operator.NotEquals,
    [priority.netitems.shared.ComparisonOperator.Lt]: Operator.Less,
    [priority.netitems.shared.ComparisonOperator.Le]: Operator.LessOrEqual,
    [priority.netitems.shared.ComparisonOperator.Gt]: Operator.Greater,
    [priority.netitems.shared.ComparisonOperator.Ge]: Operator.GreaterOrEqual,
    [priority.netitems.shared.ComparisonOperator.Between]: Operator.Between
};

export const TimeApiOperatorMapping = {
    [priority.netitems.shared.ComparisonOperator.Eq]: Operator.Equals,
    [priority.netitems.shared.ComparisonOperator.Ne]: Operator.NotEquals,
    [priority.netitems.shared.ComparisonOperator.Le]: Operator.Before,
    [priority.netitems.shared.ComparisonOperator.Ge]: Operator.Later,
    [priority.netitems.shared.ComparisonOperator.Between]: Operator.Between
};

export const DateApiOperatorMapping = {
    [priority.netitems.shared.ComparisonOperator.Eq]: Operator.Equals,
    [priority.netitems.shared.ComparisonOperator.Ne]: Operator.NotEquals,
    [priority.netitems.shared.ComparisonOperator.Le]: Operator.Before,
    // LT and GT need for compare operators from f11 to operator in column filter
    [priority.netitems.shared.ComparisonOperator.Lt]: Operator.Before,
    [priority.netitems.shared.ComparisonOperator.Gt]: Operator.Later,
    [priority.netitems.shared.ComparisonOperator.Ge]: Operator.Later,
    [priority.netitems.shared.ComparisonOperator.Between]: Operator.Between,
    [priority.netitems.shared.ComparisonOperator.IsNull]: Operator.Empty,
    [priority.netitems.shared.ComparisonOperator.IsNotNull]: Operator.NotEmpty
};

export const StrFilterOperatorMapping = {
    [priority.netitems.shared.ComparisonOperator.In]: Operator.Equals,
    [priority.netitems.shared.ComparisonOperator.Eq]: Operator.Equals,
    [priority.netitems.shared.ComparisonOperator.Ne]: Operator.NotEquals,
    [priority.netitems.shared.ComparisonOperator.Lt]: Operator.Less,
    [priority.netitems.shared.ComparisonOperator.IsNull]: Operator.Empty,
    [priority.netitems.shared.ComparisonOperator.IsNotNull]: Operator.NotEmpty
};

export const StrOperatorMapping = {
    [priority.netitems.shared.ComparisonOperator.In]: '=',
    [priority.netitems.shared.ComparisonOperator.Eq]: '=',
    [priority.netitems.shared.ComparisonOperator.Ne]: '<>',
    [priority.netitems.shared.ComparisonOperator.Lt]: '<',
    [priority.netitems.shared.ComparisonOperator.Le]: '<=',
    [priority.netitems.shared.ComparisonOperator.Gt]: '>',
    [priority.netitems.shared.ComparisonOperator.Ge]: '>=',
    [priority.netitems.shared.ComparisonOperator.Between]: ''
};
export const ColumnTypeOptions = {
    [ColumnType.Text]: [
        Operator.Contains,
        Operator.StartsWith,
        Operator.EndsWith,
        Operator.Equals,
        Operator.NotEquals,
        Operator.Empty,
        Operator.NotEmpty
    ],
    [ColumnType.Date]: [
        Operator.Between,
        Operator.Equals,
        Operator.NotEquals,
        Operator.Later,
        Operator.Before,
        Operator.Empty,
        Operator.NotEmpty
    ],
    [ColumnType.Time]: [
        Operator.Between,
        Operator.Equals,
        Operator.NotEquals,
        Operator.Later,
        Operator.Before
    ],
    [ColumnType.Duration]: [
        Operator.Between,
        Operator.Equals,
        Operator.NotEquals,
        Operator.Less,
        Operator.LessOrEqual,
        Operator.Greater,
        Operator.GreaterOrEqual
    ],
    [ColumnType.Number]: [
        Operator.Between,
        Operator.Equals,
        Operator.NotEquals,
        Operator.Less,
        Operator.LessOrEqual,
        Operator.Greater,
        Operator.GreaterOrEqual
    ],
    [ColumnType.Bool]: [Operator.Equals, Operator.NotEquals]
};

export const ZoomOperatorOptions = [
    Operator.Equals,
    Operator.NotEquals,
    Operator.Contains,
    Operator.StartsWith,
    Operator.EndsWith,
    Operator.Empty,
    Operator.NotEmpty
];

export const defaultOperators = {
    [ColumnType.Text]: Operator.Contains,
    [ColumnType.Date]: Operator.Between,
    [ColumnType.Time]: Operator.Between,
    [ColumnType.Duration]: Operator.Between,
    [ColumnType.Number]: Operator.Between,
    [ColumnType.Bool]: Operator.Equals
};

export const OperatorIconMapping = {
    [Operator.Contains]: {
        type: Operator.Contains,
        name: texts.contains,
        icon: PriorityIcon.operatorContains
    },
    [Operator.StartsWith]: {
        type: Operator.StartsWith,
        name: texts.startsWith,
        icon: PriorityIcon.operatorStartsWith
    },
    [Operator.EndsWith]: {
        type: Operator.EndsWith,
        name: texts.endsWith,
        icon: PriorityIcon.operatorEndsWith
    },
    [Operator.Between]: {
        type: Operator.Between,
        name: texts.between,
        icon: PriorityIcon.operatorSearchBetween
    },
    [Operator.Equals]: {
        type: Operator.Equals,
        name: texts.equals,
        icon: PriorityIcon.operatorEquals
    },
    [Operator.NotEquals]: {
        type: Operator.NotEquals,
        name: texts.notEquals,
        icon: PriorityIcon.operatorNotEquals
    },
    [Operator.Less]: {type: Operator.Less, name: texts.less, icon: PriorityIcon.operatorLess},
    [Operator.LessOrEqual]: {
        type: Operator.LessOrEqual,
        name: texts.lessOrEqual,
        icon: PriorityIcon.operatorLessAndEquals
    },
    [Operator.Greater]: {
        type: Operator.Greater,
        name: texts.greater,
        icon: PriorityIcon.operatorGrater
    },
    [Operator.GreaterOrEqual]: {
        type: Operator.GreaterOrEqual,
        name: texts.greaterOrEqual,
        icon: PriorityIcon.operatorGraterAndEquals
    },
    [Operator.Later]: {
        type: Operator.Later,
        name: texts.later,
        icon: PriorityIcon.operatorGrater
    },
    [Operator.Before]: {
        type: Operator.Before,
        name: texts.before,
        icon: PriorityIcon.operatorLess
    },
    [Operator.Empty]: {
        type: Operator.Empty,
        name: texts.EmptyOperator,
        icon: PriorityIcon.empty
    },
    [Operator.NotEmpty]: {
        type: Operator.NotEmpty,
        name: texts.NotEmptyOperator,
        icon: PriorityIcon.notEmpty
    }
};
